const ProfileReportErgo = () =>
    import(/*webpackChunkName: 'profile-reports'*/ '@/components/profile/reports/ergo/Ergo');
const ProfileReportRowing = () =>
    import(/*webpackChunkName: 'profile-reports'*/ '@/components/profile/reports/rowing/RowingReport');
const ProfileReportTrainingSummary = () =>
    import(
        /*webpackChunkName: 'profile-reports'*/ '@/components/profile/reports/training-summary/TrainingSummaryReport'
    );
const ProfileReportBike = () =>
    import(/*webpackChunkName: 'profile-reports'*/ '@/components/profile/reports/bike/BikeReport');

import {
    ROUTES_PROFILE_REPORT_BIKE,
    ROUTES_PROFILE_REPORT_ERGO,
    ROUTES_PROFILE_REPORT_ROWING,
    ROUTES_PROFILE_REPORT_TRAINING_SUMMARY
} from '@/constants/routes';
import { isAthlete as userIsAthlete } from '@/helpers/rolesHelper';
import store from '@/store';
import { guardRoute } from '@/router';
import get from 'get-object-path';

export const PROFILE_REPORT_ROUTES = [
    {
        path: '/profile/:id/report/ergo',
        name: ROUTES_PROFILE_REPORT_ERGO,
        meta: {
            requiresFocuses: true
        },
        beforeEnter: guardRouteErgo,
        component: ProfileReportErgo,
        props: true
    },
    {
        path: '/profile/:id/report/rowing',
        name: ROUTES_PROFILE_REPORT_ROWING,
        meta: {
            requiresFocuses: true
        },
        beforeEnter: guardRouteRowing,
        component: ProfileReportRowing,
        props: true
    },
    {
        path: '/profile/:id/report/training-summary',
        name: ROUTES_PROFILE_REPORT_TRAINING_SUMMARY,
        meta: {
            requiresFocuses: true
        },
        beforeEnter: guardRouteTrainingSummary,
        component: ProfileReportTrainingSummary,
        props: true
    },
    {
        path: '/profile/:id/report/bike',
        name: ROUTES_PROFILE_REPORT_BIKE,
        meta: {
            requiresFocuses: true
        },
        beforeEnter: guardRouteBike,
        component: ProfileReportBike,
        props: true
    }
];

async function authorized(profileId, reportPermission) {
    const profile = await store.dispatch('profileGeneral/getAthleteDetails', profileId);
    const isAthlete = userIsAthlete(get(profile || {}, 'roles.data[0].id'));
    const ownProfile = store.getters['clubHelper/me'].id === profileId;
    return ownProfile
        ? isAthlete
        : isAthlete && store.getters['userPermissions/canViewAthleteProfile'] && reportPermission;
}

async function guardRouteErgo(to, from, next) {
    const auth = await authorized(
        Number(to.params.id),
        store.getters['userPermissions/canViewAllMembersErgoProgressReport']
    );
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureAdditionalReports'];
    guardRoute(next, !auth, notInFeatureSet);
}

async function guardRouteRowing(to, from, next) {
    const auth = await authorized(
        Number(to.params.id),
        store.getters['userPermissions/canViewAllMembersWaterProgressReport']
    );
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureAdditionalReports'];
    guardRoute(next, !auth, notInFeatureSet);
}

async function guardRouteTrainingSummary(to, from, next) {
    const auth = await authorized(
        Number(to.params.id),
        store.getters['userPermissions/canViewAllMembersTrainingSummaryReport']
    );
    guardRoute(next, !auth);
}

async function guardRouteBike(to, from, next) {
    const auth = await authorized(
        Number(to.params.id),
        store.getters['userPermissions/canViewAllMembersTrainingSummaryReport']
    );
    guardRoute(next, !auth);
}
